import { MapApp } from '@/data/maps';
import * as React from 'react';

interface ArcGISContextType {
  arcGISApp: MapApp | undefined;
  setArcGISApp: React.Dispatch<React.SetStateAction<MapApp | undefined>>;
  siteWatchSearchToken: string;
}

const ArcGISContext = React.createContext<ArcGISContextType | undefined>(undefined);

interface ArcGISProviderProps {
  children: React.ReactNode;
  token: string;
}

export const useArcGIS = (): ArcGISContextType => {
  const context = React.useContext(ArcGISContext);
  if (!context) {
    throw new Error('useArcGIS must be used within an ArcGISProvider');
  }
  return context;
};

export const ArcGISProvider = ({ children, token }: ArcGISProviderProps) => {
  const [arcGISApp, setArcGISApp] = React.useState<MapApp | undefined>();

  return (
    <ArcGISContext.Provider value={{ arcGISApp, setArcGISApp, siteWatchSearchToken: token }}>
      {children}
    </ArcGISContext.Provider>
  );
};
